import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-panel tech-grid-light py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-219" data-mp="o7b968omkoeg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-220" data-mp="j883cm0tme5f">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-221" data-mp="j5c7r4cg41k5">
          Everything included
        </h2>
        <p className="mt-3 text-center text-muted" data-id="element-222" data-mp="1bvkocrrc2dwm">
          {productName} · {totalVolumes} volumes + {totalBonuses} bonuses · <b className="text-ink" data-id="element-223" data-mp="16vgcxg5a89d9">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-224" data-mp="12vftfh3bt7zc">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-cream p-4" data-id="element-225" data-mp="3rn8n8spwqgi2">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage" data-id="element-226" data-mp="3nkvfjyrlo8in">
                <CheckIcon className="h-3.5 w-3.5 text-forestDeep" aria-hidden="true" data-id="element-227" data-mp="3idxrz404gx5k" />
              </span>
              <p data-id="element-228" data-mp="3nao81rbxfsqz">
                <b className="block text-sm text-ink" data-id="element-229" data-mp="3nb7r5bdbcn6l">{feature}</b>
                <span className="text-sm text-muted" data-id="element-230" data-mp="39czp4p1f6vok">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-earth bg-cream px-6 py-5 text-center text-lg font-bold leading-relaxed text-ink" data-id="element-231" data-mp="3dc8g5m52sfgf">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}